{
  "actionbar.actions": "アクション",
  "actionbar.actionsAvailable": "アクションを利用できます。",
  "actionbar.clearSelection": "選択をクリア",
  "actionbar.selected": "{count, plural, =0 {選択されていません} other {# 個を選択済み}}",
  "actionbar.selectedAll": "すべてを選択",
  "breadcrumbs.more": "その他の項目",
  "button.pending": "保留",
  "combobox.noResults": "結果なし",
  "contextualhelp.help": "ヘルプ",
  "contextualhelp.info": "情報",
  "dialog.alert": "アラート",
  "dialog.dismiss": "閉じる",
  "dropzone.replaceMessage": "ファイルをドロップして置換",
  "inlinealert.informative": "情報",
  "inlinealert.negative": "エラー",
  "inlinealert.notice": "警告",
  "inlinealert.positive": "成功",
  "label.(optional)": "（オプション）",
  "label.(required)": "（必須）",
  "menu.moreActions": "その他のアクション",
  "notificationbadge.indicatorOnly": "新規アクティビティ",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "選択…",
  "slider.maximum": "最大",
  "slider.minimum": "最小",
  "table.loading": "読み込み中...",
  "table.loadingMore": "さらに読み込み中...",
  "table.resizeColumn": "列幅を変更",
  "table.sortAscending": "昇順に並べ替え",
  "table.sortDescending": "降順に並べ替え",
  "tag.actions": "アクション",
  "tag.hideButtonLabel": "表示を減らす",
  "tag.noTags": "なし",
  "tag.showAllButtonLabel": "すべての ({tagCount, number}) を表示",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
